<div
  [id]="tableIdPrefix + '-table-container'"
  class="matp-table-container tw-max-h-[calc(100vh_-_250px)]"
>
  <div class="matp-table-area">
    <table
      [id]="tableIdPrefix + '-table'"
      class="matp-table"
      mat-table
      matSort
      [matSortActive]="initSortState.active"
      [matSortDirection]="initSortState.direction"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="shipmentName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            配送名
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="shipmentName"
              type="text"
              [(ngModel)]="filterKeywords.shipmentName"
              (keyup)="applyFilter()"
            />
            <button
              matSuffix
              mat-icon-button
              (click)="clearFilter('shipmentName')"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element" class="tw-align-baseline">
          {{ element.shipmentName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="departureName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            出発地
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="departureName"
              type="text"
              [(ngModel)]="filterKeywords.departureName"
              (keyup)="applyFilter()"
            />
            <button
              matSuffix
              mat-icon-button
              (click)="clearFilter('departureName')"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element" class="tw-align-baseline">
          {{ element.departureName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="arrivalName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            到着地
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="arrivalName"
              type="text"
              [(ngModel)]="filterKeywords.arrivalName"
              (keyup)="applyFilter()"
            />
            <button
              matSuffix
              mat-icon-button
              (click)="clearFilter('arrivalName')"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element" class="tw-align-baseline">
          {{ element.arrivalName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="deviceName">
        <th mat-header-cell *matHeaderCellDef>
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            デバイス名
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="deviceName"
              type="text"
              [(ngModel)]="filterKeywords.deviceName"
              (keyup)="applyFilter()"
            />
            <button
              matSuffix
              mat-icon-button
              (click)="clearFilter('deviceName')"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element" class="tw-align-baseline">
          {{ element.deviceName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="battery">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-24">
          <div mat-sort-header class="matp-table-header-title tw-text-nowrap">
            バッテリー
          </div>
          <mat-form-field appearance="outline" class="matp-form-field-slim">
            <input
              matInput
              appAutocompleteOff
              name="battery"
              type="text"
              [(ngModel)]="filterKeywords.battery"
              (keyup)="applyFilter()"
            />
            <button matSuffix mat-icon-button (click)="clearFilter('battery')">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element" class="tw-align-baseline">
          <div class="tw-flex tw-items-center">
            <div class="tw-w-10">
              {{ element.battery | numeral: "0" }}
              <span *ngIf="element.battery !== undefined">%</span>
            </div>
            @if (element.battery !== undefined) {
              <div class="tw-h-6 tw-ml-1">
                <app-battery-icon
                  [batteryPercentage]="element.battery"
                ></app-battery-icon>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="operation">
        <th mat-header-cell *matHeaderCellDef class="!tw-min-w-56 tw-max-w-56">
          <div class="matp-table-header-title tw-text-nowrap">操作</div>
        </th>
        <td mat-cell *matCellDef="let element" class="!tw-w-56">
          <div
            class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-mt-1"
          >
            <button
              mat-stroked-button
              color="primary"
              class="!tw-min-w-48"
              (click)="opened.emit(element)"
            >
              <mat-icon>map</mat-icon>
              <span>デバイス位置確認</span>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    [id]="tableIdPrefix + '-table-paginator'"
    [length]="dataSource.filteredData.length"
    hidePageSize
    showFirstLastButtons
  ></mat-paginator>
</div>
